import { PHONE_SYSTEM_API } from "./constants";
import { fetcherNew1819 } from "./fetcherNew1819";
import { store } from "@redux/store";

export async function phoneSystemFetcher(action, params) {
    const usePsProxy = store.getState()?.phoneSystem?.use_ps_proxy;

    if (usePsProxy) {
        const path = params?.length ? `${action}/${params.join("/")}` : action;
        const endpoint = `threecx/${path}`;
        const result = await fetcherNew1819(endpoint);
        // Direct PS API returns text; keep proxy responses string-compatible for callers.
        if (result == null || typeof result === "string") {
            return result;
        }
        return typeof result === "object" ? JSON.stringify(result) : String(result);
    }

    const api_endpoint = PHONE_SYSTEM_API;
    const MAX_RETRIES = 3;
    let retryCount = 0;

    const options = {
        crossDomain: true,
        // Use AbortController for timeout
        signal: (() => {
            const controller = new AbortController();
            setTimeout(() => controller.abort(), 4000);
            return controller.signal;
        })(),
    };
    // add basic auth to the request
    const basicAuth = "Basic YWRtaW46cGFzc3dvcmQ=";
    options.headers = {
        Authorization: basicAuth,
    };

    while (retryCount < MAX_RETRIES) {
        try {
            const result = await fetch(api_endpoint + action + "/" + params.join("/"), options);
            if (result.ok) {
                return await result.text();
            }
            throw new Error(`HTTP error! status: ${result.status}`);
        } catch (error) {
            retryCount++;
            if (retryCount === MAX_RETRIES) {
                throw error;
            }
            // Wait before retrying
            await new Promise((resolve) => setTimeout(resolve, 1000 * retryCount));
        }
    }
}
